import {
  ChangeDetectionStrategy,
  Component,
  contentChildren,
  effect,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  signal,
  untracked,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { StepComponent } from './step.component';

@Component({
  standalone: true,
  selector: 'tt-stepper',
  templateUrl: './stepper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepperComponent {
  @HostBinding('class.tt-stepper') public hostCls = true;

  private _selected = signal(undefined);
  @Input() public set selected(value) {
    this._selected.set(value);
  }

  private _showStepNumber = signal(false);
  @Input() public set showStepNumber(value: boolean) {
    this._showStepNumber.set(value);
  }

  @Output() public stepSelected = new EventEmitter();

  private steps = contentChildren(StepComponent);

  private stepSelectedSubscriptions: Subscription[] = [];

  constructor() {
    effect(() => {
      const steps = this.steps();
      const selected = this._selected();
      const showStepNumber = this._showStepNumber();

      untracked(() => {
        this.handleStepsChange(steps, selected, showStepNumber);
      });
    });
  }

  private handleStepsChange(steps: readonly StepComponent[], selected: any, showStepNumber: boolean) {
    this.stepSelectedSubscriptions.forEach((subscription) => subscription.unsubscribe());

    steps.forEach((step, index) => {
      step.number.set(showStepNumber ? index + 1 : undefined);

      const isStepSelected = step.value ? step.value === selected : index === selected;
      step.selected.set(isStepSelected);

      const subscription = step.stepSelected.subscribe((value) => {
        this.stepSelected.emit(value ?? index);
      });

      this.stepSelectedSubscriptions.push(subscription);
    });
  }
}
